import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";

const { size } = typography;

const dialogTitle = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(12)} ${pxToRem(16)}`,
      fontSize: size.lg,
      fontWeight: 650,
      lineHeight: 1.3,
    },
  },
};

export default dialogTitle;
